export default {"bookie-logo":"PRFpN","no-padding":"cdQRP"};